<div>
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <h2 dsContent class="bold-header" [contentPath]="'policy.newVehicleDriverInfo'"></h2>
    <p dsContent [contentPath]="'policy.newVehicleDriverHeadingInfo'"></p>
    <div class="margin-top-20 margin-bottom-20">
      <h2 dsContent [contentPath]="'policy.newVehicleDriverSubHeader'"></h2>
      @for (driverName of driverNamesList$ | async; track driverName) {
        <div class="margin-top-5 margin-bottom-5">
          <p class="rowMargin">
            <span class="icon icon-complete"></span>
            <span data-cy="vehicleDriverInfoDriverName">{{ driverName }}</span>
          </p>
        </div>
      }
    </div>
    <p
      class="margin-top-50 margin-bottom-30"
      dsContent
      [contentPath]="
        (isPartner$ | async)
          ? 'policy.newVehicleDriverFooterPartnerInfo'
          : 'policy.newVehicleDriverFooterInfo'
      "
    ></p>
    <p
      dsContent
      [contentPath]="
        (isPartner$ | async)
          ? 'policy.newVehicleDriverPartnerFooter'
          : 'policy.newVehicleDriverFooter'
      "
    ></p>
  </div>

  <div class="column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [primaryButtonName]="'This is correct'"
      (primaryEvent)="correctInfo()"
      [secondaryButtonName]="(isPartner$ | async) ? 'Send to an advisor' : 'send to my agent'"
      (secondaryEvent)="notifyAgentEvent.emit({ isProcessExited: true })"
      [disableSecondaryButton]="(authorized$ | async) === false"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</div>
